"use client";

import Link from "next/link";
import ProfileIcon from "@/components/icons/ProfileIcon";
import NotificationsIcon from "@/components/icons/NotificationsIcon";
import {HeaderSettings} from "@/lib/interfaces/settings";
import {useAuth} from "@/context/auth.context";
import dynamic from "next/dynamic";
import LocationSwitcher from "@/components/LocationSwitcher";


const ThemeSwitcher = dynamic(
    () => import("@/components/ThemeSwitcher"),
    {ssr: false}
);

type NavHeaderProps = {
    settings: HeaderSettings|null
}
export default function NavHeader({settings}: NavHeaderProps) {
    const {user, loading, logout} = useAuth();

    const handleLogout = () => {
        logout();
    }

    if (settings) {
        return (
            <div className="eo-navHeader">
                {settings.profile_enabled &&
                    <>
                        {loading ?
                            <span className={"eo-spinner sz-sm"}></span>
                        :
                            <>
                                <Link href={user ? "/profile" : "/login"} className={`navHeader-item`} aria-label={"Go to your profile page"}>
                                    <span className="icon"><ProfileIcon/></span>
                                </Link>
                                {user &&
                                    <button className={"eo-button sz-xs m-action"} onClick={handleLogout}>logout</button>
                                }
                            </>
                        }
                    </>
                }
                {settings.notifications_enabled &&
                  <div className={`navHeader-item`}>
                    <span className="icon"><NotificationsIcon/></span>
                  </div>
                }
                {/*{settings.locations_enabled &&*/}
                    <div className={`navHeader-item`}>
                        <span className="icon"><LocationSwitcher/></span>
                    </div>
                {/*}*/}
                {settings.theme_switcher_enabled &&
                <div className={`navHeader-item`}>
                    <span className="icon"><ThemeSwitcher/></span>
                </div>
                }
            </div>
        )
    }
}
